import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { UploadDetailesAdapter } from './Dto/upload.detailes.adapter';
import { UploadDetailesEntity } from './Dto/upload.detailes.entity';

import { UploadDetailesController } from './upload.detailes.controller';
import { UploadDetailesService } from './upload.detailes.service';

@Module({
  imports: [
    TypeOrmModule.forFeature([UploadDetailesEntity]),
  ],
  controllers: [UploadDetailesController],
  providers: [UploadDetailesService, UploadDetailesAdapter, ApplicationExceptionHandler],
  exports: [UploadDetailesService]
})
export class UploadDetailesModule {}